import createPopupInstance from '../Popup';
import { INFO_WINDOW_DOM_ID } from './constants';
export const initializePopup = ({ maps, map, position, }) => {
    // Create a div element with ID that will be used as a container for the popup.
    // GoogleMapInfoWindow will render its content inside this div.
    const div = document.createElement('div');
    div.setAttribute('id', INFO_WINDOW_DOM_ID);
    const popup = createPopupInstance({
        maps,
        map,
        position,
        content: div,
    });
    popup.setMap(map);
    return popup;
};
